import React from "react";
import "./App.css";
import Header from "./components/Header";
import Hero from "./components/Hero";
import TrustBadges from "./components/TrustBadges";
import HowItWorks from "./components/HowItWorks";
import DeepDive from "./components/DeepDive";
import PerformanceStats from "./components/PerformanceStats";
import LiveMarketData from "./components/LiveMarketData";
import ProfitSimulatorEnhanced from "./components/ProfitSimulatorEnhanced";
import LeadCaptureForm from "./components/LeadCaptureForm";
import ReviewsCarousel from "./components/ReviewsCarousel";
import Pricing from "./components/Pricing";
import Blog from "./components/Blog";
import MarketNews from "./components/MarketNews";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Header />
      <main className="pt-36 sm:pt-32">
        <Hero />
        <TrustBadges />
        <LiveMarketData />
        <HowItWorks />
        <DeepDive />
        <PerformanceStats />
        <ProfitSimulatorEnhanced />
        <section className="py-16 px-4 sm:px-6 lg:px-8 bg-black">
          <div className="container mx-auto">
            <LeadCaptureForm 
              variant="inline"
              title="Get Free AI Trading Signals"
              subtitle="Join 10,000+ traders receiving daily market insights"
            />
          </div>
        </section>
        <ReviewsCarousel />
        <Pricing />
        <section className="py-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-b from-black to-slate-950">
          <div className="container mx-auto">
            <LeadCaptureForm 
              title={<>Start Trading with <span className="bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent">AI Today</span></>}
              subtitle="Get instant access to our AI trading platform. No credit card required."
            />
          </div>
        </section>
        <Blog />
        <MarketNews />
      </main>
      <Footer />
    </div>
  );
}

export default App;
